import { AdminInvestmentList, ProductPermissionEnum } from 'api';
import { BatchConfirmTypes } from 'apps/issuer/shared/confirm-investments-table-view/types';
import { currentTokenHasPermission } from 'src/apps/issuer/helpers/tokenPermissions';

export function useInvestmentsFilteredByConfirmPermissions(
  data: AdminInvestmentList[] | undefined,
  type: BatchConfirmTypes,
) {
  let permission: ProductPermissionEnum;
  if (type === 'approveOffers') permission = ProductPermissionEnum.MANAGE_APPROVALS;
  if (type === 'confirmPayments') permission = ProductPermissionEnum.MANAGE_INCOMING_PAYMENTS;

  if (!data?.length) return;

  return data.filter((investment) => currentTokenHasPermission(investment.token, permission));
}
